var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.179688 13.371094 C 35.078125 12.496094 32.023438 9.054688 31.636719 4.882812 L 31.636719 4 L 24.746094 4 L 24.746094 31.34375 C 24.738281 33.824219 23.148438 36.027344 20.796875 36.816406 C 18.441406 37.605469 15.847656 36.804688 14.347656 34.828125 L 14.34375 34.828125 L 14.347656 34.828125 C 12.820312 32.820312 12.769531 30.050781 14.226562 27.988281 C 15.683594 25.925781 18.304688 25.042969 20.710938 25.808594 L 20.710938 18.808594 C 15.351562 18.070312 10.113281 20.816406 7.675781 25.648438 C 5.242188 30.476562 6.144531 36.324219 9.925781 40.195312 C 13.519531 43.875 18.988281 45.011719 23.753906 43.070312 C 28.523438 41.128906 31.636719 36.492188 31.636719 31.347656 L 31.636719 17.375 C 34.421875 19.363281 37.761719 20.433594 41.183594 20.425781 L 41.183594 13.578125 C 40.511719 13.582031 39.835938 13.511719 39.179688 13.371094 Z M 39.179688 13.371094 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.5a8a9b268180d46046f52d9d51191f47.svg";
export { ForwardRef as ReactComponent };